exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a[data-v-1e1441b2]{color:#fffde4}.responses table[data-v-1e1441b2]{color:#fff}.responses .legacy[data-v-1e1441b2]{opacity:.4}.icon-cell[data-v-1e1441b2]{font-size:1.4em;padding:.3em .75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e1441b2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Responses.vue
// module id = 33
// module chunks = 0